<template>
    <div class="com-item news-module" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: modata.WContent.bgColor || 'transparent',
                backgroundImage: modata.WContent.bgImg ? 'url(' + modata.WContent.bgImg + ')' : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: modata.WContent.textColor || '#333'
            }">
                <div class="news-module__inner">
                    <!-- <div class="news-module__head" v-if="modata.WContent.enTitle || modata.WContent.cnTitle|| modata.WContent.btnText">
                        <div class="news-module__title">
                            <p class="news-module__en">{{ modata.WContent.enTitle }}</p>
                            <p class="news-module__cn">{{ modata.WContent.cnTitle }}</p>
                        </div>
                        <a
                            v-if="modata.WContent.btnText"
                            class="news-module__more"
                            :href="modata.WContent.btnLink && modata.WContent.btnLink.linkUrl ? modata.WContent.btnLink.linkUrl : 'javascript:void(0);'"
                            target="_self"
                        >{{ modata.WContent.btnText }}</a>
                    </div> -->


                    <div class="techShow-module__title">
                        <div>
                            <div class="techShow-module__head" v-if="modata.WContent.enTitle">
                                <p class="techShow-module__en">{{ modata.WContent.enTitle }}</p>
                            </div>
                            <div class="techShow-module__sub">{{ modata.WContent.cnTitle }}</div>
                        </div>
                        <a v-if="modata.WContent.btnText" class="techShow-module__cta"
                            :href="modata.WContent.btnLink && modata.WContent.btnLink.linkUrl ? modata.WContent.btnLink.linkUrl : 'javascript:void(0);'"
                            target="_self">
                            <span>{{ modata.WContent.btnText }}</span>
                        </a>
                    </div>





                    <div class="news-module__list" :class="[modata.WContent.showType == 3 ? 'news-list3' : 'news-list1']"
                        v-if="cards && cards.length">
                        <div v-for="(card, cIdx) in cards" :key="cIdx" class="news-module__card">
                            <div class="news-module__card-item">
                                <a class="news-module__card-img"
                                    :href="(card.linkUrl && typeof card.linkUrl === 'object' ? card.linkUrl.linkUrl : card.linkUrl) || 'javascript:void(0);'"
                                    target="_blank‌">
                                    <img v-if="card.imgUrl" :src="card.imgUrl" alt="" />
                                </a>
                                <div class="news-module__card-body" v-if="card.date || card.title">
                                    <div class="word">
                                        <p class="news-module__card-title">
                                            <a :href="(card.linkUrl && typeof card.linkUrl === 'object' ? card.linkUrl.linkUrl : card.linkUrl) || 'javascript:void(0);'"
                                                target="_blank‌">{{
                                                    card.title }}</a>
                                        </p>
                                        <p class="news-module__card-date">{{ card.date }}</p>
                                    </div>
                                    <img src="@/assets/images/arrow.png" class="arrow" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getPageList } from '@/request/api'

export default {
    name: "news-module",
    components: {},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function () {
                return {
                    WName: 'news',
                    Title: '新闻中心',
                    MID: 15,
                    WID: null,
                    ModuleName: 'news-module',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {
            cards: []
        }
    },
    mounted() {
        this.fetchNewsList()
    },
    beforeDestroy() { },
    watch: {
        "modata.WContent.showType": function () {
            this.fetchNewsList()
        },
        "modata.WContent.showCount": function () {
            if ((this.modata && this.modata.WContent && this.modata.WContent.showType) === 1) {
                this.fetchNewsList()
            }
        }
    },
    methods: {
        fetchNewsList() {
            const that = this
            const W = (this.modata && this.modata.WContent) || {}
            const showType = W.showType || 1
            if (showType === 3) {
                const manual = Array.isArray(W.manualCards) ? W.manualCards : []
                that.cards = manual.map(function (item) {
                    return {
                        date: item.subTitle || '',
                        title: item.title || '',
                        imgUrl: item.imgUrl || '',
                        linkUrl: item.linkUrl || ''
                    }
                })
                return
            }
            const showCount = W.showCount || 3
            const para = {
                pageParm: {
                    page: 1,
                    limit: showCount,
                    keyword: '',
                    field: '',
                    sort: 0
                },
                isEnable: null,
                isFooter: '0',
                pageType: showType === 2?4:2,
                title: ''
            }
            getPageList(para).then(res => {
                if (res.code === 200 && res.data && Array.isArray(res.data.data)) {
                    that.cards = res.data.data.map(item => ({
                        date: (item.modifyTime || item.createTime) ? (item.modifyTime || item.createTime).split(" ")[0] : '',
                        title: item.title || '',
                        imgUrl: item.imgUrl || '',
                        linkUrl: item.externalLink || ("/article/detail/" + item.id)
                    }))
                } else {
                    that.cards = []
                }
            }).catch(() => {
                that.cards = []
            })
        }
    },
    filters: {}
}
</script>

<style scoped lang="scss">
@import "../../assets/style/news.scss";

.news-module {
    background: linear-gradient(to right, #fff, #f8f8f8);
    margin-bottom: 30px;
}
@media screen and (max-width: 768px) {
    .news-module {
     margin-bottom: 18px;
     }
}
</style>
